import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { Policy } from 'src/domains/players/webview/components/Account/resetPasswordProcedure/resetPasswordForm/Policy';

export const ResetPasswordCookies = observer('ResetPasswordCookies', () => {
    return <Policy id='cookies-policy' />;
});
